import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {User} from "../../../shared/interface/user";
import {takeUntil} from "rxjs/operators";
import {Ofwca} from "../../../shared/interface/ofwca";
import {Partner} from "../../../shared/interface/partner";
import {UserService} from "../../../shared/services/user.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormBuilder} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {DictService, FILE_TYPE_SALES_PROCESS_VERIFICATION_FORM} from "../../../shared/services/dict.service";
import {AvatarCropDialogComponent} from "../../user/avatar-crop-dialog/avatar-crop-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {DocumentAddDialogComponent} from "../../documents/document-add-dialog/document-add-dialog.component";
import {NoteAddDialogComponent} from "../../note/note-add-dialog/note-add-dialog.component";
import {DeviceAddDialogComponent} from "../device-add-dialog/device-add-dialog.component";
import {LicenseAddDialogComponent} from "../license-add-dialog/license-add-dialog.component";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {Device} from "../../../shared/interface/device";
import {ActivatedRoute} from "@angular/router";
import {License} from "../../../shared/interface/license";
import {UserPermissions} from "../../../shared/interface/user-permissions";

@Component({
  selector: 'app-user-licenses-details-view',
  templateUrl: './user-licenses-details-view.component.html',
  styleUrls: ['./user-licenses-details-view.component.scss']
})
export class UserLicensesDetailsViewComponent implements OnInit, OnDestroy, AfterViewInit {


  @Input() user?: Observable<User>;
  @Output() modifyClicked = new EventEmitter<any>();

  userObject?: User;
  devices: ReplaySubject<Device[]> = new ReplaySubject<Device[]>(1);
  licenses: ReplaySubject<License[]> = new ReplaySubject<License[]>(1);
  userId?: string = null;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private snack: MatSnackBar,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private auth: AuthService,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.userId = params.id;
        this.loadDevices();
        this.loadLicenses();
      });
    this.user
      .pipe(takeUntil(this.destroyed$))
      .subscribe((user: User) => {
        this.userObject = user;
      });
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  addLicense(): void {
    const dialogRef = this.dialog.open(LicenseAddDialogComponent, {
      width: '90%',
      data: {user: this.userObject},
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadLicenses();
    });
  }

  addDevice(): void {
    const dialogRef = this.dialog.open(DeviceAddDialogComponent, {
      width: '90%',
      data: {user: this.userObject},
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadDevices();
    });
  }

  loadDevices(): void {
    this.userService.getDevices(this.userId)
      .subscribe((devices: ListResponse<Device>) => {
        this.devices.next(devices.items);
      });
  }

  loadLicenses(): void {
    this.userService.getLicenses(this.userId)
      .subscribe((licenses: ListResponse<License>) => {
        this.licenses.next(licenses.items);
      });
  }

}
